import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./search-locality.scss";
import Image from "../../components/image/image";
import SearchBar from "../../components/search-bar/search-bar";
import LocationIcon from "../../assets/locationIcon.svg";
import ExitButton from "../../assets/exit.png";
import BackButton from "../../assets/backward.png";
import LocIcon from "../../assets/locIcon.svg";
import Loader from "../../components/loader/loader";
import GetDiningLocationAPI from "../../services/GetDiningLocation/GetDiningLocation";
import NoOutletIcon from "../../assets/no-outlet.svg";
import { pageUrl } from "../../utils/pageConstant";

const SearchLocality = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [popularLocation, setPopularLocation] = useState([]);
  const [isLoader, setIsLoader] = useState(true);

  const currentCity = location.state?.cityName

  const handleBack = () => {
    navigate(pageUrl.SEARCH_CITY, {
      state: { city: sessionStorage.getItem("city") },
    });
  };

  const onHandleCloseBtn = () => {
    navigate("/outlet-list");
  };

  const handleNavigate = (localityName) => {
    sessionStorage.setItem("city", currentCity);
    sessionStorage.setItem("locality", localityName);
    sessionStorage.removeItem("apiCityValue");
    sessionStorage.removeItem("apiLocalityValue");
    sessionStorage.removeItem("storedRestoList");
    sessionStorage.removeItem("storedRestoType");
    navigate(pageUrl.EXPLORE, {
      state: { localityName: localityName, cityName: location.state?.cityName },
    });
  };

  useEffect(() => {
    getDiningLocality(location?.state?.cityName);
  }, [location]);

  const getDiningLocality = async (cityName) => {
    try {
      const responseData = await GetDiningLocationAPI(cityName);
      setPopularLocation(responseData);
      setIsLoader(false);
    } catch (error) {
      console.log("getDiningLocality---", error);
    }
  };

  return (
    <div className="search-locality-page">
      {isLoader && <Loader />}
      <div className="locationPageControls">
        <img style={{height: "30px"}} src={BackButton} alt="x" onClick={handleBack}/>
        <img style={{height: "30px"}} src={ExitButton} alt="x" onClick={onHandleCloseBtn}/>
      </div>
      <div className="search-header">You are looking to Dine-in</div>
      <div className="search-sub-header">
        Select Locality or Landmark in
        <span className="city-text">{location.state?.cityName}</span>
      </div>
      {/* <SearchBar searchLabel="Locality, Landmark, Project..." handleNaviagte={handleNavigate}/> */}
      <div className="pop-locality-text">Popular Localities</div>
      <div className="popular-locality-section">
        {popularLocation?.map((locality, index) => (
          <div
            key={index}
            className="popular-locality"
            onClick={() => handleNavigate(locality?.name)}
          >
            <div className="loc-left">
              <Image src={LocIcon} alt="" imgStyle="locality-img" />
              <span className="loc-text">{locality?.name}</span>
            </div>
            <div className="loc-right">
              <span>&#8377;</span>{" "}
              {`${Number(locality.distance).toFixed(2) + "k/sq.ft"}`}
            </div>
          </div>
        ))}
        { !isLoader && (popularLocation?.length === 0)?
          <div className="location-not-found">
            <Image src={NoOutletIcon} imgStyle="" alt="no outlets" />
          </div>
          : null
        }
        { !isLoader && (popularLocation?.length > 0)?
          <div
            className="popular-locality"
            onClick={() => handleNavigate("")}
          >
            <div className="loc-left">
              <Image src={LocIcon} alt="" imgStyle="locality-img" />
              <span className="loc-text">{"All Outlets"}</span>
            </div>
            <div className="loc-right">
              <span>{"-"}</span>
            </div>
          </div> : null
        }
      </div>
    </div>
  );
};

export default SearchLocality;
